const ADD_CODEBOOK = "ADD_CODEBOOK";

export const addCodebook = (codebookName, collection) => ({
  type: ADD_CODEBOOK,
  codebookName: codebookName,
  collection: collection
});
